<template>
  <section class="faq">
    <img class="absolute block-lg hidden car-image" src="@/assets/images/car-2.png" />
    <div class="max-w-screen-lg mx-auto">
      <h3 class="faq-title">{{ t.frequentQuestionTitle }}</h3>

      <div class="question-list">
        <AccordionComponent :key="index" v-for="(item, index) in faqs" class="accordion" :title="item.title" :content="item.content" :icon="accordionIcon" />
      </div>
    </div>
  </section>
</template>

<style lang="scss">
@import '@/assets/styles/mixins';

.faq {
  position: relative;
  padding: 7.5rem var(--content-side-padding);
  color: var(--background);
  background: var(--neutral-90) url('/assets/faq-background.svg') no-repeat right top;

  .car-image {
    left: calc(68% - 192px);
    top: 2px;
    transform: translateY(-100%);
    width: 175px;
    height: 135px;
  }

  &-title {
    color: var(--background);
    font-weight: 700;
    font-size: 2.25rem;
    line-height: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .question-list {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .accordion-container {
    width: 100%;

    .divider {
      background: var(--neutral-60);
    }
  }

  .accordion {
    border: 2px solid var(--neutral-60);
    border-radius: 1.5rem;

    .title {
      font-weight: 600;
      line-height: 1.5rem;
    }
  }

  .content {
    color: var(--background);
  }

  svg * {
    fill: var(--background);
    stroke: var(--background);
  }
}
</style>
<script>
import AccordionComponent from '@/components/Accordion/Accordion.vue'
import { langMixin } from '@/lang.js'
import IconExpandRight from '@/assets/icons/chevRight.svg'

export default {
  components: { AccordionComponent },
  mixins: [langMixin('Home')],
  computed: {
    accordionIcon() {
      return IconExpandRight
    },
    faqs() {
      return JSON.parse(this.t.frequentQuestions || '[]')?.slice(0, 3)
    }
  }
}
</script>
